import React from "react";
import { Box, Modal, Typography } from "@mui/material";
import CustomDarkButton from "../buttons/CustomDarkButton";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ConfirmationModal = ({
  open,
  onAccept,
  title = null,
  onClose,
  children = null,
}) => {
  return (
    <Modal
      open={open}
      // onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box>
          <Box sx={{ marginBottom: "2rem" }}>
            <Typography
              sx={{
                fontSize: "1.5rem",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              {title}
            </Typography>
          </Box>
          {children && <Box>{children}</Box>}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CustomDarkButton
              handleClick={onAccept}
              title={<CheckIcon />}
              className="w-fit-content ms-2"
            />
            <CustomDarkButton
              handleClick={onClose}
              title={<ClearIcon />}
              className="w-fit-content ms-2"
            />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
